// Ekipman türü görseli: Süper Admin'in yüklediği resim, yoksa gruba göre renkli ikon
import { Truck, Wrench } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TONES = ['bg-sky-100 text-sky-700', 'bg-rose-100 text-rose-700', 'bg-amber-100 text-amber-700', 'bg-violet-100 text-violet-700', 'bg-emerald-100 text-emerald-700', 'bg-teal-100 text-teal-700'];

export const kindImageUrl = (kind) => (kind?.image_path ? `${API}/equipment-kind-images/${kind.id}?v=${encodeURIComponent(kind.image_path.slice(-12))}` : null);

export const EquipmentKindImage = ({ kind, index = 0, size = 'h-11 w-14' }) => {
  const url = kindImageUrl(kind);
  const Icon = kind?.main_type === 'arac' ? Truck : Wrench;
  return (
    <span className={`flex shrink-0 items-center justify-center overflow-hidden rounded-lg ${size} ${url ? 'bg-white' : TONES[index % TONES.length]}`} data-testid={`eq-kind-img-${kind?.subtype_key}`}>
      {url ? <img src={url} alt={kind.subtype_label} decoding="async" fetchpriority="high" className="h-full w-full object-contain p-0.5" /> : <Icon className="h-6 w-6" />}
    </span>
  );
};
